import { render, staticRenderFns } from "./ShopMemberResetPassword.vue?vue&type=template&id=713df1cd&"
import script from "./ShopMemberResetPassword.vue?vue&type=script&lang=js&"
export * from "./ShopMemberResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports